/* Progressive disclosure only: the complete canonical link tree remains in HTML. */
(() => {
  const mobile = window.matchMedia('(max-width: 820px)');
  let serial = 0;
  const button = (text, target, label) => {
    if (!target.id) target.id = `ha-menu-branch-${++serial}`;
    const el = document.createElement('button');
    el.type = 'button'; el.className = 'ha-menu-disclosure'; el.textContent = text;
    el.setAttribute('aria-controls', target.id);
    el.setAttribute('aria-expanded', 'false');
    if (label) el.setAttribute('aria-label', label);
    return el;
  };
  const setOpen = (control, content, open) => {
    control.setAttribute('aria-expanded', String(open));
    content.hidden = !open;
    if (control.classList.contains("ha-menu-group-toggle")) {
      const column=control.closest(".main-nav__panel-col");
      if(column?.dataset.nav2Node==="exhausts") {
        column.classList.toggle("ha-menu-exhausts-open",open);
        column.closest(".main-nav__panel").classList.toggle("ha-menu-exhausts-active",open);
      }
    }
  };
  function enhanceCategoryRail(panel, grid) {
    if (grid.querySelector(':scope > .ha-menu-category-rail')) return;
    const kind = panel.dataset.menuKind || 'menu';
    const allColumns = [...grid.children].filter(el => el.matches('.main-nav__panel-col'));
    const commerceColumns = allColumns.filter(el => el.hasAttribute('data-nav2-node'));
    const columns = commerceColumns.length ? commerceColumns : allColumns.filter(el => el.querySelector(':scope > ul'));
    const railTitle = kind === 'custom-ecu' ? panel.dataset.menuTuningCategories : kind === 'brand' ? panel.dataset.menuBrandGroups : panel.dataset.menuCategories;
    if (!columns.length) return;
    panel.dataset.menuCompact = 'true';
    panel.classList.add('ha-menu-category-layout');
    const lead = allColumns.find(column => !columns.includes(column));
    if (lead) lead.classList.add('ha-menu-category-lead');
    const rail = document.createElement('div');
    rail.className = 'ha-menu-category-rail';
    const railLabel = document.createElement('div');
    railLabel.className = 'ha-menu-category-label';
    railLabel.textContent = railTitle;
    const chooserLabel = document.createElement('label');
    chooserLabel.className = 'ha-menu-mobile-label';
    const chooser = document.createElement('select');
    chooser.id = `ha-menu-category-${++serial}`;
    chooser.className = 'ha-menu-category-select';
    chooserLabel.htmlFor = chooser.id;
    chooserLabel.textContent = ['brand', 'blogs'].includes(kind) ? panel.dataset.menuChooseSection : panel.dataset.menuChooseCategory;
    const categoryNav = document.createElement('nav');
    categoryNav.className = 'ha-menu-category-buttons';
    categoryNav.setAttribute('aria-label', railTitle);
    rail.append(railLabel, chooserLabel, chooser, categoryNav);
    const content = document.createElement('div');
    content.className = 'ha-menu-category-content';
    grid.append(rail, content);
    const categories = [];
    columns.forEach((column, index) => {
      const heading = column.querySelector(':scope > .main-nav__panel-heading');
      if (!heading) return;
      const label = heading.textContent.trim();
      const choice = document.createElement('button');
      choice.type = 'button';
      choice.className = 'ha-menu-category-button';
      const choiceText = document.createElement('span');
      choiceText.textContent = label;
      const arrow = document.createElement('span');
      arrow.className = 'ha-menu-category-arrow';
      arrow.textContent = '›';
      arrow.setAttribute('aria-hidden', 'true');
      choice.append(choiceText, arrow);
      if (!column.id) column.id = `ha-menu-category-body-${++serial}`;
      choice.setAttribute('aria-controls', column.id);
      const option = document.createElement('option');
      option.value = String(index);
      option.textContent = label;
      chooser.append(option);
      categoryNav.append(choice);
      const shortcuts = document.createElement('div');
      shortcuts.className = 'ha-menu-category-shortcuts';
      const oldShortcuts = column.querySelector('.ha-exhaust-shortcuts');
      const shortcutLinks = oldShortcuts ? [...oldShortcuts.querySelectorAll('a')] : [];
      let actions = [
        ['brand', panel.dataset.menuShopBrand, shortcutLinks[0]?.getAttribute('href') || '/pages/partners'],
        ['vehicle', panel.dataset.menuShopVehicle, shortcutLinks[1]?.getAttribute('href') || '/pages/vehicle-search'],
        ['all', panel.dataset.menuShopAll, heading.getAttribute('href')]
      ];
      if (kind === 'custom-ecu') actions = [
        ['how', panel.dataset.menuTuningHow, '/collections/custom-ecu-tuning-home#how-tuning-works'],
        ['guides', panel.dataset.menuTuningGuides, '/blogs/news/tagged/tuning'],
        ['all', panel.dataset.menuTuningAll, heading.getAttribute('href')]
      ];
      else if (kind === 'brand') actions = [
        ['brand', panel.dataset.menuShopAllBrands, '/pages/partners'],
        ['vehicle', panel.dataset.menuShopVehicle, '/pages/vehicle-search'],
        ['all', panel.dataset.menuShopAllProducts, '/collections/all-products']
      ];
      else if (kind === 'merch') actions = [
        ['all', panel.dataset.menuShopAll, heading.getAttribute('href')],
        ['merch', panel.dataset.menuAllMerch, '/collections/merchandise']
      ];
      else if (kind === 'blogs') actions = [
        ['all', panel.dataset.menuAllArticles, heading.getAttribute('href')],
        ['guides', panel.dataset.menuProductGuides, '/blogs/news/tagged/product-guides'],
        ['builds', panel.dataset.menuCustomerBuilds, '/blogs/news/tagged/customer-builds']
      ];
      shortcuts.style.setProperty('--ha-menu-shortcut-count', String(actions.length));
      actions.forEach(([action, label, destination]) => {
        const link = document.createElement('a');
        link.className = 'ha-menu-category-shortcut';
        link.dataset.menuShop = action;
        link.href = destination;
        const text = document.createElement('span');
        text.className = 'ha-menu-shortcut-label';
        link.setAttribute('aria-label', label);
        const words = label.trim().split(/\s+/);
        // Break the translated label at the most balanced word boundary.
        let split = 1;
        for (let index = 2; index < words.length; index += 1) {
          const balance = at => Math.abs(words.slice(0, at).join(' ').length - words.slice(at).join(' ').length);
          if (balance(index) < balance(split)) split = index;
        }
        [words.slice(0, split).join(' '), words.slice(split).join(' ')].filter(Boolean).forEach((line, index) => {
          const row = document.createElement('span');
          row.className = 'ha-menu-shortcut-line';
          row.textContent = (index ? ' ' : '') + line;
          text.append(row);
        });
        const marker = document.createElement('span');
        marker.textContent = '→';
        marker.setAttribute('aria-hidden', 'true');
        link.append(text, marker);
        shortcuts.append(link);
      });

      if (oldShortcuts) oldShortcuts.remove();
      const subheading = document.createElement('h3');
      subheading.className = 'ha-menu-subcategories-label';
      subheading.textContent = kind === 'custom-ecu' ? panel.dataset.menuMakesModels
        : kind === 'brand' ? panel.dataset.menuBrands
        : kind === 'blogs' ? (column.querySelector('[data-menu-articles]') ? panel.dataset.menuReadNext : panel.dataset.menuTopics)
        : panel.dataset.menuSubcategories;
      heading.after(shortcuts, subheading);
      column.classList.add('ha-menu-category-detail');
      content.append(column);
      choice.addEventListener('click', () => select(index));
      categories.push({ index, column, choice });
    });
    function select(index) {
      categories.forEach(category => {
        const active = category.index === index;
        category.column.hidden = !active;
        category.choice.setAttribute('aria-pressed', String(active));
      });
      chooser.value = String(index);
      panel.dataset.menuSelectedCategory = categories.find(category => category.index === index)?.column.dataset.nav2Node || categories.find(category => category.index === index)?.column.dataset.menuGroup || '';
    }
    chooser.addEventListener('change', () => select(Number(chooser.value)));
    const footer = document.createElement('div');
    footer.className = 'ha-menu-category-footer';
    const help = document.createElement('a');
    help.href = '/pages/contact';
    help.textContent = `${kind === 'menu' ? panel.dataset.menuFitmentHelp : panel.dataset.menuContactUs} →`;
    footer.append(help);
    grid.append(footer);
    panel.classList.toggle('ha-menu-content-layout', kind !== 'menu');
    select(categories[0].index);
    grid.querySelectorAll('li > ul').forEach(list => {
      const item = list.parentElement;
      const link = item.querySelector(':scope > a, :scope > .ha-menu-branch-label');
      if (!link) return;
      const row = document.createElement('div');
      row.className = 'ha-menu-branch-heading';
      link.before(row);
      row.append(link);
      const toggle = button('+', list, link.textContent.trim());
      row.append(toggle);
      setOpen(toggle, list, false);
      toggle.addEventListener('click', () => setOpen(toggle, list, toggle.getAttribute('aria-expanded') !== 'true'));
    });
    panel.addEventListener('ha:menu-close', () => {
      panel.querySelectorAll('.ha-menu-disclosure[aria-expanded="true"]').forEach(control => {
        const target = document.getElementById(control.getAttribute('aria-controls'));
        if (target) setOpen(control, target, false);
      });
    });
    panel.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const list = event.target.closest('li > ul');
      const control = list && panel.querySelector(`button[aria-controls="${list.id}"][aria-expanded="true"]`);
      if (!control) return;
      setOpen(control, list, false);
      control.focus();
      event.preventDefault();
      event.stopPropagation();
    });
  }

  function enhance(panel) {
    if (panel.matches('[data-nav2-vehicle-panel]')) return;
    if (panel.hasAttribute('data-menu-category-rail')) {
      const grid = panel.querySelector('[data-nav2-panel-grid]');
      if (grid) enhanceCategoryRail(panel, grid);
      return;
    }
    if (panel.dataset.menuCompact) return;
    const grid = panel.querySelector('[data-nav2-panel-grid]');
    if (!grid || !grid.querySelector('.main-nav__panel-col')) return;
    panel.dataset.menuCompact = 'true';
    const columns = [...grid.children].filter(el => el.matches('.main-nav__panel-col'));
    if(['unpublished','development'].includes(window.Shopify?.theme?.role)) grid.querySelectorAll('[data-exhaust-component-unavailable]').forEach(el=>{el.hidden=false;});
    const groups = [];
    const longLists = [];
    panel.classList.add('ha-menu-dense');

    columns.forEach(column => {
      const heading = column.querySelector(':scope > .main-nav__panel-heading');
      if (!heading || column.querySelector('[data-menu-articles]')) return;
      const hasChildren = !!column.querySelector('ul > li');
      if (column === columns[0] && !hasChildren) return;
      const body = document.createElement('div'); body.className = 'ha-menu-group-body';
      while (heading.nextSibling) body.append(heading.nextSibling);
      const row = document.createElement('div'); row.className = 'ha-menu-group-heading';
      column.append(row, body); row.append(heading);
      const toggle = button('+', body, `Expand ${heading.textContent.trim()}`);
      toggle.classList.add('ha-menu-group-toggle'); row.append(toggle);
      if (!hasChildren) {
        toggle.disabled = true;
        toggle.removeAttribute('aria-controls');
        toggle.removeAttribute('aria-expanded');
        toggle.setAttribute('aria-label', `${heading.textContent.trim()}: no further options`);
        return;
      }
      const group = {toggle, body}; groups.push(group);
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        if (open) groups.forEach(other => { if (other !== group) setOpen(other.toggle, other.body, false); });
        setOpen(toggle, body, open);
      });
    });

    // Descendant links are expanded separately from following their collection link.
    grid.querySelectorAll('li').forEach(item => {
      const list = item.querySelector(':scope > ul');
      const link = item.querySelector(':scope > a, :scope > .ha-menu-branch-label');
      if (!link || !list) return;
      const row = document.createElement('div'); row.className = 'ha-menu-branch-heading';
      link.before(row); row.append(link);
      const toggle = button('+', list, `Expand ${link.textContent.trim()}`); row.append(toggle);
      setOpen(toggle, list, false);
      toggle.addEventListener('click', () => setOpen(toggle, list, toggle.getAttribute('aria-expanded') !== 'true'));
    });
    grid.querySelectorAll('ul').forEach(list => {
      if (list.hasAttribute('data-menu-articles') || list.hasAttribute('data-exhaust-component-grid')) return;
      const items = [...list.children].filter(el => el.tagName === 'LI');
      if (items.length <= 4) return;
      const more = button('View more', list); more.classList.add('ha-menu-more');
      list.after(more);
      const update = () => {
        const limit = mobile.matches ? 4 : 6;
        const expanded = more.getAttribute('aria-expanded') === 'true';
        items.forEach((item, i) => { item.hidden = i >= limit && !expanded; });
        more.hidden = items.length <= limit;
        more.textContent = expanded ? 'Show fewer' : `View more (${items.length - limit})`;
        more.setAttribute('aria-label', `${expanded ? 'Show fewer' : 'View more'} ${list.closest('.main-nav__panel-col').querySelector('.main-nav__panel-heading')?.textContent.trim() || 'options'}`);
      };
      more.addEventListener('click', () => {
        more.setAttribute('aria-expanded', String(more.getAttribute('aria-expanded') !== 'true')); update();
      });
      longLists.push(update);
    });
    const responsive = () => {
      panel.classList.toggle('ha-menu-small', mobile.matches);
      groups.forEach(({toggle, body}) => {
        setOpen(toggle, body, false);
      });
      longLists.forEach(update => update());
    };
    mobile.addEventListener('change', responsive); responsive();
    panel.addEventListener('ha:menu-close', () => {
      panel.querySelectorAll('button[aria-expanded="true"]').forEach(control => {
        if (control.classList.contains('ha-menu-more')) control.click();
        else {
          const content = panel.querySelector(`[id="${control.getAttribute('aria-controls')}"]`);
          if (content) setOpen(control, content, false);
        }
      });
    });
    panel.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      // Close the nearest open branch before the existing header closes the menu.
      const containers = [...panel.querySelectorAll('[id]')].filter(el => !el.hidden && el.contains(event.target));
      const content = containers.reverse().find(el => panel.querySelector(`button[aria-controls="${el.id}"][aria-expanded="true"]`));
      if (!content) return;
      const control = panel.querySelector(`button[aria-controls="${content.id}"]`);
      if (control.classList.contains('ha-menu-more')) control.click();
      else setOpen(control, content, false);
      control.focus(); event.preventDefault(); event.stopPropagation();
    });
  }
  const init = () => {
    const header = document.querySelector('#site-header');
    if (!header) return;
    header.dataset.menuEnhancement = 'on-demand-v1';
    // Keep the complete Liquid link tree available, but do not build controls
    // for hidden panels during first paint. The opener dispatches synchronously
    // before measuring the panel, so its first interaction uses the final layout.
    header.addEventListener('ha:menu-before-open', event => {
      if (event.target.matches('.main-nav__panel')) enhance(event.target);
    });
    header.querySelectorAll('.main-nav__item.is-open > .main-nav__panel').forEach(enhance);
    new MutationObserver(records => {
      const openPanels = new Set();
      records.forEach(record => {
        const panel = record.target.closest?.('.main-nav__panel');
        if (panel?.closest('.main-nav__item.is-open')) openPanels.add(panel);
        record.addedNodes.forEach(node => {
          if (node.nodeType !== 1 || !node.isConnected) return;
          if (node.matches('.main-nav__panel') && node.closest('.main-nav__item.is-open')) openPanels.add(node);
          node.querySelectorAll('.main-nav__item.is-open > .main-nav__panel').forEach(candidate => openPanels.add(candidate));
        });
      });
      openPanels.forEach(enhance);
    }).observe(header, {childList: true, subtree: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
